import React from 'react';
import PropTypes from 'prop-types';
import LogoutLink from './LogoutLink';
import Counter from './Counter';
import BizTag from './BizTag';
import {Message} from '@aperza/ui';

import TdLink from './TdLink';

import AppService from '../service/AppService';
import type AppConfig from '../domain/AppConfig';
const appConfig: AppConfig = AppService.appConfig();

import { target } from 'react-aim';
@target()
class UserMenuList extends React.Component {
  static propTypes = {
    viewer: PropTypes.any.isRequired
  };

  render() {
    let { viewer } = this.props;

    return (
      <div className="userMenuList">
        <div className="userName">
          <TdLink
            action="usermenu_mytop"
            href={`https://account${appConfig.baseComDomain}/`}
            anchorMessageId="userMenu.name"
            anchorMessageValue={{ name: viewer.displayName }}
          >
            <p className="name">
              <Message
                messageId="userMenu.name"
                values={{ name: viewer.displayName }}
              />
            </p>
          </TdLink>
          {viewer.isBusiness &&
            viewer.companyName && (
              <p className="company">{viewer.companyName}</p>
            )}
        </div>
        <div className="menuList">
          <TdLink
            className="menuItem td-click"
            action="usermenu_clip"
            href={`https://account${appConfig.baseComDomain}/clip`}
            anchorMessageId="userMenu.clip.title"
          >
            <p className="title">
              <Message messageId="userMenu.clip.title" />
            </p>
            <p className="caption">
              <Message messageId="userMenu.clip.caption" />
            </p>
          </TdLink>

          <TdLink
            className="menuItem td-click"
            action="usermenu_history"
            href={`https://account${appConfig.baseComDomain}/history`}
            anchorMessageId="userMenu.history.title"
          >
            <p className="title">
              <Message messageId="userMenu.history.title" />
            </p>
            <p className="caption">
              <Message messageId="userMenu.history.caption" />
            </p>
          </TdLink>

          <TdLink
            className="menuItem td-click"
            action="usermenu_mail"
            href={`https://account${appConfig.baseComDomain}/mail`}
            anchorMessageId="userMenu.mail.title"
          >
            <p className="title">
              <Message messageId="userMenu.mail.title" />
            </p>
            <p className="caption">
              <Message messageId="userMenu.mail.caption" />
            </p>
          </TdLink>

          <TdLink
            className="menuItem td-click"
            action="usermenu_account"
            href={`https://account${appConfig.baseComDomain}/account`}
            anchorMessageId="userMenu.account.title"
          >
            <p className="title">
              <Message messageId="userMenu.account.title" />
            </p>
            <p className="caption">
              <Message messageId="userMenu.account.caption" />
            </p>
          </TdLink>

          <TdLink
            className="menuItem td-click"
            action="usermenu_message"
            href={`https://${appConfig.baseCluezMemberDomain}/${
              viewer.locale
            }/message/list`}
            anchorMessageId="userMenu.message.title"
            openOnNewTab={true}
          >
            <p className="title">
              <Message messageId="userMenu.message.title" />&nbsp;{viewer.unreadMessageCount >
                0 && <Counter count={viewer.unreadMessageCount} />}
            </p>
            <p className="caption">
              <Message messageId="userMenu.message.caption" />
            </p>
          </TdLink>

          {viewer.isBusiness && (
            <TdLink
              className="menuItem td-click"
              action="usermenu_biz"
              href={`https://cloud${appConfig.baseComDomain}/home/index.html`}
              anchorMessageId="userMenu.marketing.title"
            >
              <p className="title">
                <Message messageId="userMenu.marketing.title" />&nbsp;<BizTag />
              </p>
              <p className="caption">
                <Message messageId="userMenu.marketing.caption" />
              </p>
            </TdLink>
          )}

          {viewer.isActiveBusiness && (
            <TdLink
              className="menuItem td-click"
              action="usermenu_biz"
              href={`https://business${
                appConfig.baseComDomain
              }/f/order/index.html`}
              anchorMessageId="userMenu.bizAccount.title"
            >
              <p className="title">
                <Message messageId="userMenu.bizAccount.title" />&nbsp;<BizTag />
              </p>
              <p className="caption">
                <Message messageId="userMenu.bizAccount.caption" />
              </p>
            </TdLink>
          )}
        </div>
        <LogoutLink />
      </div>
    );
  }
}

export default UserMenuList;
